import { Column, Entity, PrimaryGeneratedColumn } from 'typeorm';
import { BaseEntite, EntiteStatique, FiltrableEntiteStatique } from '.';

@FiltrableEntiteStatique<HistoriqueLogs>()
@EntiteStatique()
@Entity('historique_logs')
export class HistoriqueLogs implements BaseEntite {
    static key = 'historique_logs';

    static non_privileged_properties: (keyof HistoriqueLogs)[] = [];
    static regular_privileged_properties: (keyof HistoriqueLogs)[] = ['id', 'name'];
    static admin_privileged_properties: (keyof HistoriqueLogs)[] = [];

    @PrimaryGeneratedColumn()
    id: number;
    @Column()
    name: string;
    @Column()
    nom_table: string;
    @Column()
    id_element: number;
    @Column({ nullable: true })
    nom_element: string;
    @Column()
    nom_usager: string;
    @Column({ type: 'text' })
    api_body = '';
    @Column({ type: 'timestamp', nullable: true })
    date_modification = '';
}
